var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInflg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2932_13962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4444C0 14.0928 0.257539 14.7145 0.715961 15.1729C1.17438 15.6314 1.79614 15.8889 2.44444 15.8889H19.5556C20.2039 15.8889 20.8256 15.6314 21.284 15.1729C21.7425 14.7145 22 14.0928 22 13.4444V11H0V13.4444Z",
    fill: "#138808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.88867H22V11H0V4.88867Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4.88867V2.44444C22 1.79614 21.7425 1.17438 21.284 0.715961C20.8256 0.257539 20.2039 0 19.5556 0H2.44444C1.79614 0 1.17438 0.257539 0.715961 0.715961C0.257539 1.17438 0 1.79614 0 2.44444V4.88867H22Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9991 10.3889C12.3492 10.3889 13.4436 9.29447 13.4436 7.94444C13.4436 6.59442 12.3492 5.5 10.9991 5.5C9.6491 5.5 8.55469 6.59442 8.55469 7.94444C8.55469 9.29447 9.6491 10.3889 10.9991 10.3889Z",
    fill: "#000080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 9.77751C12.0119 9.77751 12.8327 8.9567 12.8327 7.94417C12.8327 6.93165 12.0119 6.11084 10.9993 6.11084C9.98683 6.11084 9.16602 6.93165 9.16602 7.94417C9.16602 8.9567 9.98683 9.77751 10.9993 9.77751Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 6.11084L11.0886 7.4944L11.7003 6.25078L11.2542 7.56284L12.2955 6.6474L11.3807 7.68934L12.6927 7.24262L11.4491 7.85495L12.8327 7.94417L11.4491 8.0334L12.6927 8.64512L11.3807 8.19901L12.2955 9.24034L11.2542 8.32551L11.7003 9.63756L11.0886 8.39395L10.9993 9.77751L10.9101 8.39395L10.2978 9.63756L10.7445 8.32551L9.70257 9.24034L10.618 8.19901L9.30596 8.64512L10.5496 8.0334L9.16602 7.94417L10.5496 7.85495L9.30596 7.24262L10.618 7.68934L9.70257 6.6474L10.7445 7.56284L10.2978 6.25078L10.9101 7.4944L10.9993 6.11084Z",
    fill: "#6666B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 8.55523C11.3373 8.55523 11.6109 8.28163 11.6109 7.94412C11.6109 7.60661 11.3373 7.33301 10.9998 7.33301C10.6623 7.33301 10.3887 7.60661 10.3887 7.94412C10.3887 8.28163 10.6623 8.55523 10.9998 8.55523Z",
    fill: "#000080"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 14.8889,
    rx: 2.5,
    stroke: "#E7E7E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2932_13962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15.8889,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflg);
export default __webpack_public_path__ + "static/media/inflg.535663ed3d968d003516a81441ca3ccf.svg";
export { ForwardRef as ReactComponent };